import React from "react";
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import ModalButtons from "../ModalButtons/ModalButtons";
import HoldBuilderErrors from "./HoldBuilderErrors";
import HoldBuilderWorkspace from "./HoldBuilderWorkspace";
import ReactPortalsRoot from "../ReactPortalsRoot/ReactPortalsRoot";
import ModalWarning from "../ModalWarning/ModalWarning";
import Tabs from "../Tabs/Tabs";
import {addDays, parseISO} from "date-fns";
import TextConfirmation from "../ModalWarning/TextConfirmation";

class HoldBuilder extends React.Component {

  constructor(props) {
    super(props)
    var today = new Date()
    this.state = {
      errors: [],
      active_tab: 'general',
      loading: false,
      id: this.props.id,
      is_new: this.props.is_new || false,
      date_format: this.props.date_format,
      room: this.props.room,
      rooms: [],
      room_type_name: this.props.room_type_name || null,
      check_in_date: this.props.check_in_date ? parseISO(this.props.check_in_date) : today,
      check_out_date: this.props.check_out_date ? parseISO(this.props.check_out_date) : addDays(new Date(), 1),
      displayWarningModal: false,
      multiRoomRoomType: false,
      overbooked: false,
      displayConfirmToSave: false,
      submitTextConfirmed: false, 
      submitCheckboxConfirmed: false, 

      reason: '',
      note_obj: {
        note: null,
        notable_type: null,
        notable_id: null,
        flagged: false,
        user: null,
        created_at: null,
        updated_at: null
      },
      hold_create_path: this.props.hold_create_path,
      hold_update_path: this.props.hold_update_path
    }

    this.setActiveTab = this.setActiveTab.bind(this)
    this.onSubmit = this.onSubmit.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeNote = this.onChangeNote.bind(this)
    this.onChangeRooms = this.onChangeRooms.bind(this)
    this.onChangeFlagged = this.onChangeFlagged.bind(this)
    this.onChangeImageGroup = this.onChangeImageGroup.bind(this)
    this.warningModalBody = this.warningModalBody.bind(this)
  }

  render(){
    if (this.state.overbooked) {
      var buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.setState({
              displayWarningModal: true,
            });
          },
        },
      ];
    } else if (this.state.multiRoomRoomType && !this.state.overbooked) {
      var buttons = [
        {
          name: I18n.t("cancel"),
          html_attributes: ['data-dismiss="modal"'],
        },
        {
          name: I18n.t("submit"),
          button_classes: ["primary"],
          onClick: (e) => {
            e.stopPropagation();
            e.preventDefault();
            this.setState({
              displayConfirmToSave: true,
            });
          },
        },
      ];
    } else {
      var buttons = [
        {
          name: I18n.t('cancel'),
          html_attributes: ['data-dismiss="modal"']
        },
        {
          name: I18n.t('submit'),
          button_classes: ['primary'],
          onClick: this.onSubmit,
        },
      ]

    }
   

    return(
      <div className="HoldBuilder">
        <div className="panel panel-form">
          <ModalButtons loading={this.state.loading} buttons={buttons}/>
          <Tabs tabs={this.tabs()} displayErrorMessage={HoldBuilderErrors.general(this.state.errors).length ? true : false} />
          <HoldBuilderWorkspace
            {...this.state}
            onChange={this.onChange}
            onChangeFlagged={this.onChangeFlagged}
            onChangeImageGroup={this.onChangeImageGroup}
            onChangeNote={this.onChangeNote}
            onChangeRooms={this.onChangeRooms}
            buttons={buttons}/>
        </div>
        {
          (this.state.displayConfirmToSave)
          ?
            (<ReactPortalsRoot
              children={[
                <ModalWarning
                  key="body"
                  title={I18n.t("ota_availability")}
                  body={this.renderConfirmToBook()}
                  CancelSubmit={true}
                  onSubmit={this.onSubmit}
                  onCancel={() => this.setState({ displayConfirmToSave: false, submitCheckboxConfirmed: false, submitTextConfirmed : false})}
                  disabled_buttons={this.activeWarningModalButtons()}
                />
              ]}
              wrapperClassNames="ModalWarningWrapper"
            />)
          :
          null
        }
        {this.state.displayWarningModal ? (
          <ReactPortalsRoot
            children={[
              <ModalWarning
                key="body"
                title={I18n.t("overbooking_warning")}
                body={this.warningModalBody()}
                CancelSubmit={true}
                onSubmit={this.onSubmit}
                onCancel={() => this.setState({ displayWarningModal: false, submitTextConfirmed: false, submitCheckboxConfirmed: false})}
                disabled_buttons={this.activeWarningModalButtons()}
              />
            ]}
            wrapperClassNames="ModalWarningWrapper"
          />
        ) : null}
        <LoadingSpinner show={this.state.loading} />
      </div>
    )
  }

  tabs() {
    return(
      [
        {
          tabName: I18n.t('general'),
          targetName: 'general',
          classes: this.state.active_tab === 'general' ? 'active' : null,
          changeHandler: this.setActiveTab,
          tabErrorCount:  HoldBuilderErrors.general(this.props.errors).length,
        },
        {
          tabName: I18n.t('notes'),
          targetName: 'notes',
          classes: this.state.active_tab === 'notes' ? 'active' : null,
          changeHandler: this.setActiveTab,
        }
      ]
    );
  };

 
  setActiveTab(name) {
    this.setState({active_tab: name});
  };

  onChange(name, value) {
    this.state[name] = value;
    if (this.state.rooms && this.state.check_in_date && this.state.check_out_date) {
      this.checkAvailability();
    };
    this.forceUpdate();
  };

  onChangeImageGroup(image_group) {
    this.setState({ image_group: image_group });
  };

  warningModalBody() {
    return (
      <div className="modal-body">
        <div className="col-sm-12 FeeBuilderUpdateFolioItems">
          <div className="row">
            <div className="folio-items-alert" >{I18n.t("overbooking_warning_text")}</div>
          </div>
          <br />
        </div>
        <div className="alert alert-warning" style={{ marginBottom: 0 }} role="alert">
          <TextConfirmation 
            onTextConfirmation={this.onConfirmText} 
            onDoubleTextConfirmation={this.onConfirmCheckbox} 
            showDoubleConfirmation={true} 
            environment={"development"} 
            />
        </div>
        <LoadingSpinner show={this.props.loading} />
      </div>
    );
  };

  renderConfirmToBook = () => {
    return (
      <div className="modal-body">
        <div className="col-sm-12 FeeBuilderUpdateFolioItems">
          <div className="row">
            <div className="folio-items-alert warning-message" >{I18n.t('hold_ota_consecutive_days_warning')}</div>
          </div>
          <br />
        </div>
        <div className="alert alert-warning" style={{ marginBottom: 0 }} role="alert">
          <TextConfirmation 
            onTextConfirmation={this.onConfirmText} 
            onDoubleTextConfirmation={this.onConfirmCheckbox} 
            showDoubleConfirmation={true} 
            environment={"development"} 
            />
        </div>
        <LoadingSpinner show={this.props.loading} />
      </div>
    );
  };

  onConfirmText = (value) => {
    this.setState({
      submitTextConfirmed: value
    });
  };

  onConfirmCheckbox = (value) => {
    this.setState({
      submitCheckboxConfirmed: value
    });
  };

  activeWarningModalButtons = () => {
    if (this.state.submitTextConfirmed && this.state.submitCheckboxConfirmed) {
      return false;
    } else {
      return true;
    };
  };

  onChangeNote(noteText) {
    if (noteText) {
      var note_obj = Object.assign({}, this.state.note_obj)
      note_obj.note = noteText

      this.setState({
        note_obj: note_obj
      })
    }
  }

  onChangeFlagged(e) {
    var note_obj = this.state.note_obj;
    note_obj['flagged'] = e.target.checked
    this.setState({note_obj: note_obj});
  }

  onChangeRooms(rooms) {
    this.setState({
      rooms: rooms,
    })
  }

  onSubmit() {
    var self = this;
    var holds = [];
    if (this.state.rooms && this.state.rooms.length > 0) {
      self.state.rooms.forEach(room => {
        holds.push({
          id: self.state.id,
          room_id: room.id,
          check_in_date: self.state.check_in_date.toISOString(),
          check_out_date: self.state.check_out_date.toISOString(),
          reason: self.state.reason,
          note_obj: self.state.note_obj
        });
      });

    } else {
      
      holds = {
        id: self.state.id,
        room_id: self.state.room.id,
        check_in_date: self.state.check_in_date.toISOString(),
        check_out_date: self.state.check_out_date.toISOString(),
        reason: self.state.reason,
        note_obj: self.state.note_obj
      };
    }
    
    self.setState({ loading: true });
    setTimeout(function () {
      $.ajax({
        type: self.state.is_new ? 'POST' : 'PATCH',
        url: self.state.is_new ? self.state.hold_create_path : self.state.hold_update_path,
        data: { holds }
      }).done(function (data) {
        if (Object.keys(data.errors).length) {
          self.setState({
            loading: false,
            errors: data.errors,
            displayWarningModal: false,
          });
        } else {
          self.setState({ loading: false });
          if (parent && parent.refresh_data) {
            parent.refresh_data(I18n.t('hold_successfully_created'));
          }
          if (parent && parent.hide_modal) {
            parent.hide_modal();
          }
        }
      });
    }, 1000);
  }

  checkAvailability() {
    this.setState({ loading: true})
    $.ajax({
      type: "POST",
      url: this.props.check_availability_path,
      data: {
        id: this.props.id,
        // room_type_id: this.state.room ? this.state.room.room_type_id : null,
        // room_id: this.state.room ? this.state.room.id : null,
        // taken_room_ids: this.state.rooms ? this.state.rooms.map(r => r.id) : null,
        check_in_date: this.state.check_in_date,
        check_out_date: this.state.check_out_date,
      }
    }).done((data) => {
      if (data && !data.errors) {
        this.setState({
          loading: false,
          overbooked: data.overbooked,
          multiRoomRoomType: data.multi_room_room_type_warning,
          errors: {},
        })
      } else {
        this.setState({
          loading: false,
          errors: data.errors
        })
      }
    })
  }

}

export default HoldBuilder
